var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiRrGift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fi-rr-gift",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_72159",
    "data-name": "Group 72159",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72158",
    "data-name": "Group 72158",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91705",
    "data-name": "Path 91705",
    d: "M26.667,9.333H24.349A6.849,6.849,0,0,0,26.667,4,1.333,1.333,0,0,0,24,4c0,3.5-3.161,4.707-5.565,5.121A12.443,12.443,0,0,0,20,4a4,4,0,1,0-8,0,12.443,12.443,0,0,0,1.565,5.121C11.161,8.707,8,7.5,8,4A1.333,1.333,0,0,0,5.333,4,6.849,6.849,0,0,0,7.651,9.333H5.333A5.333,5.333,0,0,0,0,14.667V16a2.667,2.667,0,0,0,2.667,2.667v6.667A6.675,6.675,0,0,0,9.333,32H22.667a6.675,6.675,0,0,0,6.667-6.667V18.667A2.667,2.667,0,0,0,32,16V14.667A5.333,5.333,0,0,0,26.667,9.333ZM16,2.667A1.333,1.333,0,0,1,17.333,4,10.28,10.28,0,0,1,16,8.017,10.28,10.28,0,0,1,14.667,4,1.333,1.333,0,0,1,16,2.667Zm-13.333,12A2.667,2.667,0,0,1,5.333,12h9.333v4h-12ZM5.333,25.333V18.667h9.333V29.333H9.333a4,4,0,0,1-4-4Zm21.333,0a4,4,0,0,1-4,4H17.333V18.667h9.333ZM17.333,16V12h9.333a2.667,2.667,0,0,1,2.667,2.667V16Z",
    transform: "translate(0 0)",
    fill: "currentColor"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrGift);
export default __webpack_public_path__ + "static/media/fi-rr-gift.e8a3153fd26fd1b21f5d283c419d8563.svg";
export { ForwardRef as ReactComponent };